import React from 'react'
import PropTypes from 'prop-types'
import ProgressiveImage from 'react-progressive-image'
import placeholder from './placeholder3.png'

const Image = ({ src, style, centered }) => {
  return (
    <ProgressiveImage src={src} placeholder={placeholder}>
      {(source) => (
        <img
          src={source || ''}
          alt="image"
          style={{
            background: '#d8d8d8',
            maxHeight: 150,
            maxWidth: '100%',
            display: 'block',
            ...centered && { margin: 'auto' },
            ...style,
          }}
        />
      )}
    </ProgressiveImage>
  )
}

Image.propTypes = {
  src: PropTypes.string,
  style: PropTypes.object,
  centered: PropTypes.bool,
}
Image.defaultProps = {
  src: '',
  style: {},
  centered: true,
}

export default Image



// WEBPACK FOOTER //
// ./src/components/images/Image.js